import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, Text, View } from 'react-native';
import Hr from 'LocalGluons/components/Hr';
import Theme from 'Theme';

const styles = StyleSheet.create({
    itemDivider: {
        marginTop: 14
    },
    title: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: Theme.primaryFontSize,
        textTransform: 'uppercase'
    }
});

const SectionPlayListHeader = ({ title }) => (
    <View>
        <Text style={styles.title}>{title}</Text>
        <Hr style={styles.itemDivider} />
    </View>
);

SectionPlayListHeader.propTypes = {
    title: PropTypes.string.isRequired
};

export default SectionPlayListHeader;
